// 格式化日期: yyyy.MM.dd
function formatDate(date) {
	const year = date.getFullYear()
	let month = date.getMonth() + 1
	let day = date.getDate()
	return (`${year}.${month}.${day}`)
}

export function formatCurrentDateByNianYueRi() {
	const date = new Date();
	const year = date.getFullYear()
	let month = date.getMonth() + 1
	let day = date.getDate()
	return (`${year}年${month}月${day}日`)
}
// 近X天
export function getDay(day) {
	var today = new Date();
	var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
	today.setTime(targetday_milliseconds);
	var tYear = today.getFullYear();
	var tMonth = today.getMonth()+1;
	var tDate = today.getDate();
	return tYear + "." + tMonth + "." + tDate;
}
// 本月
export function getNowMonth() {
	var today = new Date();
	var tYear = today.getFullYear();
	var tMonth = today.getMonth();
	var tDate = today.getDate();
	tMonth = tMonth + 1;
	tDate = "01"
	return tYear + "." + tMonth + "." + tDate;
}
 
// 上月日期
export function getLastMonth() {
	const date = new Date()
	const year = date.getFullYear()
	const month = date.getMonth()
	const lastMonthStartDate = formatDate(new Date(year, month - 1, 1))
	const lastMonthEndDate = formatDate(new Date(year, month, 0))
	const lastMonth = []
	lastMonth.push(lastMonthStartDate, lastMonthEndDate)
	return lastMonth
}

export function getWeekTime() {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth() + 1;
    const date = now.getDate();
    const day = now.getDay();
    const start = new Date(year, month - 1, date - day);
    const end = new Date(year, month - 1, date + (6 - day));
    const startDateStr = `${start.getFullYear()}.${start.getMonth() + 1}.${start.getDate()}`;
    const endDateStr = `${end.getFullYear()}.${end.getMonth() + 1}.${end.getDate()}`;
    let week = []
	week.push(startDateStr, endDateStr)
	return week
}